import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import { Divider } from "@/components/ui/divider";
import React from 'react';
import { IconM, IconMC } from '@/components/media/IconsV2';
import ModalBase from '@/components/basic/ModalBase';
import i18n from '@/assets/i18n';
import CancelButton from '@/components/basic/CancelButton';
import { ScrollView } from 'react-native-gesture-handler';

export default function ModalIcons({ showModal, setShowModal }) {
    const mIcons = ['edit', 'phone-android', 'keyboard-arrow-left', 'lock', 'redo', 'photo-library', 'language', 'login', 'logout', 'qr-code-2', 'analytics', 'keyboard-arrow-right', 'file-download', 'format-list-bulleted', 'remove', 'settings', 'delete', 'content-copy', 'videocam', 'rocket-launch', 'pause', 'tv', 'person', 'fullscreen', 'info-outline', 'event-available', 'more-vert', 'add', 'undo', 'group', 'clear', 'qr-code', 'photo-camera', 'color-lens', 'share', 'cloud-done', 'home', 'sync-problem', 'cloud-off', 'play-arrow', 'desktop-windows', 'security', 'close', 'keyboard-arrow-down', 'smartphone', 'audiotrack', 'construction', 'help-outline', 'account-tree', 'support-agent'].sort()
    const mcIcons = ['check-circle-outline', 'shape-outline', 'close-circle', 'pencil', 'phone', 'close-circle-outline', 'check-circle', 'target', 'flag-checkered', 'undo', 'checkbox-blank-circle-outline', 'close', 'checkbox-marked-circle-outline'].sort()

    const COLS = 5
    const mRows = []
    for (let i = 0; i < mIcons.length; i += COLS) {
        mRows.push(mIcons.slice(i, i + COLS))
    }
    const mcRows = []
    for (let i = 0; i < mcIcons.length; i += COLS) {
        mcRows.push(mcIcons.slice(i, i + COLS))
    }
    return (
        <ModalBase showModal={showModal}>
            <Text className="text-2xl leading-2xl text-secondary-900">{i18n.t('adminModal.icons')}</Text>
            <ScrollView height='60%'>
                <VStack space='sm' className="items-center bg-secondary-50 w-[100%]">
                    <Text className="text-2xl leading-2xl text-secondary-900">Material</Text>
                    {mRows.map((row, r) =>
                        <HStack key={'M' + r} space='sm'>
                            {row.map((icon, i) =>
                                <VStack key={'MI' + i}>
                                    <View className="w-[46px] p-1 bg-primary-50 border border-primary-900 rounded-[4px] items-center">
                                        <IconM className="text-4xl text-primary-900" name={icon} />
                                    </View>
                                    <View horizontal={true} className="w-[48px]" >
                                        <Text className="text-xs text-secondary-900">{icon}</Text>
                                    </View>
                                </VStack>
                            )}
                        </HStack>)}
                    <Divider />
                    <Text className="text-2xl leading-2xl text-secondary-900">MaterialCommunity</Text>
                    {mcRows.map((row, r) =>
                        <HStack key={'MV' + r} space='sm'>
                            {row.map((icon, i) =>
                                <VStack key={'MCI' + i}>
                                    <View className="w-[46px] p-1 bg-primary-50 border border-primary-900 rounded-[4px] items-center">
                                        <IconMC className="text-4xl text-primary-900" name={icon}/>
                                    </View>
                                    <View horizontal={true} className="w-[48px]" >
                                        <Text className="text-xs text-secondary-900">{icon}</Text>
                                    </View>
                                </VStack>
                            )}
                        </HStack>)}
                </VStack>
            </ScrollView>
            <VStack space='md' className="pt-3 w-[100%]">
                <CancelButton onPress={() => setShowModal(false)} text={i18n.t('appSettings.cancel')} />
            </VStack>
        </ModalBase>
    );
}